import { API } from 'aws-amplify'

const sanitize = (string) => {
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    "/": '&#x2F;',
    "`": '&grave',
  };
  const reg = /[&<>"'/]/ig;
  return string.replace(reg, (match) => (map[match]));
}

export class CustomersService {
  
listMyCustomers(params) {
  const listMyCustomers = `query ListMyCustomers($limit: Int!, $nextToken: String) {
            listMyCustomers(limit: $limit, nextToken: $nextToken) {
              customers {
                customerId
                primaryEmail
                secondaryEmail
                customerNr
                organization
                company
                company2
                country
                language
                telephone
                firstName
                surName
                pkwData
                lkwData
                createdAt
                updatedAt
                updatedBy
                owner
              }
              nextToken
            }
          }`
  return API.graphql({ query: listMyCustomers, variables: params })
}

listAllCustomers(params) {
  const listAllCustomers = `query ListAllCustomers($limit: Int!, $nextToken: String) {
            listAllCustomers(limit: $limit, nextToken: $nextToken) {
              customers {
                customerId
                primaryEmail
                secondaryEmail
                customerNr
                organization
                company
                company2
                country
                language
                telephone
                firstName
                surName
                pkwData
                lkwData
                createdAt
                updatedAt
                updatedBy
                owner
              }
              nextToken
            }
          }`
  return API.graphql({ query: listAllCustomers, variables: params })
}

createCustomer(params) {
  const createCustomer = `mutation CreateCustomer($customer: CreateCustomerInput!) {
        createCustomer(customer: $customer) {
          __typename
          customerId
          primaryEmail
          secondaryEmail
          customerNr
          organization
          company
          company2
          country
          language
          telephone
          firstName
          surName
          pkwData
          lkwData
          createdAt
          updatedAt
        }
      }`
  return API.graphql({ query: createCustomer, variables: params })
}

updateCustomer(params) {
  const updateCustomer = `mutation updateCustomer ($customerId: ID!, $customer: UpdateCustomerInput!) {
        updateCustomer(customerId: $customerId, customer: $customer) {
          company
          company2
          country
          createdAt
          customerId
          customerNr
          firstName
          language
          lkwData
          organization
          pkwData
          primaryEmail
          secondaryEmail
          surName
          telephone
          updatedAt
          updatedBy
        }
      }`

  return API.graphql({ query: updateCustomer, variables: params })
}

deleteCustomer(params) {
  const deleteCustomer = `mutation deleteCustomer ($customerId: ID!) {
        deleteCustomer(customerId: $customerId) {
          customerNr
        }
      }`

  return API.graphql({ query: deleteCustomer, variables: params })
}

adminDeleteCustomer(params) {
  const adminDeleteCustomer = `mutation adminDeleteCustomer ($customerId: ID!, $owner: String!) {
        adminDeleteCustomer(customerId: $customerId, owner: $owner) {
          customerNr
        }
      }`

  return API.graphql({ query: adminDeleteCustomer, variables: params })
}

// deleteCustomers(params) {
//   const deleteCustomer = `mutation deleteCustomer ($customerId: ID!) {
//         deleteCustomer(customerId: $customerId) {
//           customerNr
//         }
//       }`

//   return API.graphql({ query: deleteCustomer, variables: params })
// }

getCsvUploadUrl(params) {
  const getCsvUploadUrl = `query getCsvUploadUrl ($name: String!) {
        getCsvUploadUrl(name: $name)
      }`
  return API.graphql({ query: getCsvUploadUrl, variables: params })
}
  }

export default CustomersService